import { IconButton } from '@atlaskit/button/new';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { token } from '@atlaskit/tokens';
import React from 'react';

import { useSendSideNavCreateButtonClick } from '@townsquare/analytics-nav4';

import { CommonSideNavItemProps, DefaultItemType } from '../../../types';

const DefaultSideNavItem = ({ isSelected, onClick, item }: CommonSideNavItemProps & { item: DefaultItemType }) => {
	const sendCreateButtonClickEvent = useSendSideNavCreateButtonClick();
	const { hoverAction } = item;

	return (
		<LinkMenuItem
			key={item.analyticsSubject}
			onClick={e => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			elemBefore={<item.Icon label="" />}
			testId={item.testId}
			actionsOnHover={
				hoverAction ? (
					<IconButton
						icon={iconProps => (
							<hoverAction.Icon {...iconProps} color={isSelected ? token('color.icon.selected') : undefined} />
						)}
						appearance="subtle"
						spacing="compact"
						label={hoverAction.label}
						tooltip={{ content: hoverAction.label }}
						isTooltipDisabled={false}
						onClick={() => {
							sendCreateButtonClickEvent(item.analyticsSubject);
							hoverAction?.onClick?.();
						}}
					/>
				) : null
			}
		>
			{item.name}
		</LinkMenuItem>
	);
};

export default DefaultSideNavItem;
